import { render, staticRenderFns } from "./PublisherRegistrationPageForm.vue?vue&type=template&id=6e2d26e5"
import script from "./PublisherRegistrationPageForm.vue?vue&type=script&lang=js"
export * from "./PublisherRegistrationPageForm.vue?vue&type=script&lang=js"
import style0 from "./PublisherRegistrationPageForm.vue?vue&type=style&index=0&id=6e2d26e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports